import { render, staticRenderFns } from "./FormGetProductBySKUMultiple.vue?vue&type=template&id=20b512d0&scoped=true&"
import script from "./FormGetProductBySKUMultiple.vue?vue&type=script&lang=js&"
export * from "./FormGetProductBySKUMultiple.vue?vue&type=script&lang=js&"
import style0 from "./FormGetProductBySKUMultiple.vue?vue&type=style&index=0&id=20b512d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b512d0",
  null
  
)

export default component.exports